/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetYoutubePlaylistsQueryResponse, GetYoutubePlaylistsPathParams } from "../models/GetYoutubePlaylists";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getYoutubePlaylists } from "../axios/getYoutubePlaylists";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getYoutubePlaylistsQueryKey = (station: GetYoutubePlaylistsPathParams["station"]) => ["social-export-api", { url: '/youtube/:station/playlists', params: {station:station} }] as const

export type GetYoutubePlaylistsQueryKey = ReturnType<typeof getYoutubePlaylistsQueryKey>

export function getYoutubePlaylistsQueryOptions(station: GetYoutubePlaylistsPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getYoutubePlaylistsQueryKey(station)
        return queryOptions<GetYoutubePlaylistsQueryResponse, ResponseErrorConfig<Error>, GetYoutubePlaylistsQueryResponse, typeof queryKey>({
         enabled: !!(station),
         queryKey,
         queryFn: async ({ signal }) => {
            return getYoutubePlaylists(station, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns all playlists owned by the authenticated user for the station
 * @summary Get YouTube playlists for a station
 * {@link /youtube/:station/playlists}
 */
export function useGetYoutubePlaylists<TData = GetYoutubePlaylistsQueryResponse, TQueryData = GetYoutubePlaylistsQueryResponse, TQueryKey extends QueryKey = GetYoutubePlaylistsQueryKey>(station: GetYoutubePlaylistsPathParams["station"], options: 
{
  query?: Partial<QueryObserverOptions<GetYoutubePlaylistsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getYoutubePlaylistsQueryKey(station)
         

         const query = useQuery({
          ...getYoutubePlaylistsQueryOptions(station, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}